<template>
<div v-if="current">
    <div class="panel">
        <playerCustomizeModal v-if="showPlayerStatsModal" :playerId="clickedPlayerId" @closeMessage="showPlayerStatsModal = false"></playerCustomizeModal>
        <spinningModal v-if="showSpinner"></spinningModal>
        <add-treasury-modal v-if="showAddTreasuryModal" :teamId="id" @closeMessage="showAddTreasuryModal = false"></add-treasury-modal>
        <team-detail-header :actions="false" :team="current"></team-detail-header>
        <confirmModal v-if="showModePurchaseConfirmModal"
                      message="Si vous passez cette équipe en mode achat, elle pourra dépenser ses sous, comme après un match. OK ?"
                      @confirm="activatePurchases()"
                      @closeMessage="showModePurchaseConfirmModal = false"></confirmModal>
      <confirmModal v-if="showModeUpgradeConfirmModal"
                    message="Si vous passez cette équipe en mode montée de niveau, elle pourra dépenser ses XP, comme après un match. OK ?"
                    @confirm="activateUpgrade()"
                    @closeMessage="showModePurchaseConfirmModal = false"></confirmModal>
      <confirmModal v-if="showEndOfSeasonConfirmModal"
                    message="Si vous terminez la saison de cette équipe, elle ne pourra plus jouer de matchs sur la saisopn actuelle, et les calculs d'intersaisons seront lancés. OK ?"
                    @confirm="finishSeason()"
                    @closeMessage="showEndOfSeasonConfirmModal = false"></confirmModal>
        <messageModal v-if="showActivatedPurchaseModeMessage" message="L'équipe a été basculée en mode achat" @closeMessage="showActivatedPurchaseModeMessage = false"></messageModal>
        <messageModal v-if="showActivateEndOfSeasonMessage" message="L'équipe a terminé sa saison, elle est en mode intersaison" @closeMessage="showActivateEndOfSeasonMessage = false"></messageModal>
        <div class="panel-content panel-top">
          <div class="row columns">
            <div class="large-2 columns">
                <button class="button-bar" @click="showAddTreasuryModal=true"><span><i class="fa fa-gift" aria-hidden="true"></i>&nbsp;Ajouter de la Trésorerie</span></button>
            </div>
            <div class="large-3 columns"  v-if="current.status === 1">
                <button class="button-bar" @click="showModeUpgradeConfirmModal = true"><span><i class="fa fa-money" aria-hidden="true"></i>&nbsp;Mettre en mode montée de niveau</span></button>
            </div>
            <div class="large-2 columns"  v-if="current.status === 1">
              <button class="button-bar" @click="showModePurchaseConfirmModal = true"><span><i class="fa fa-money" aria-hidden="true"></i>&nbsp;Mettre en mode Achat</span></button>
            </div>
            <div class="large-2 columns">
              <button class="button-bar" @click="showEndOfSeasonConfirmModal = true"><span><i class="fa fa-flag-checkered" aria-hidden="true"></i>&nbsp;Terminer la saison</span></button>
            </div>
            <div class="large-3 columns">
              <router-link :to="{ name: 'TeamDetail', params: { id: current.id }}" >
                <button @click="showPublishConfirmModal = true" class="button-bar validation-btn">
                  <span><i class="fa fa-thumbs-o-up" aria-hidden="true"></i>&nbsp;&nbsp; Terminer les modifs</span>
                </button>
              </router-link>
            </div>
          </div>
        <div class="row columns">
            <div class="large-12">
                <div class="inner-title">Les Joueurs : </div>
                <table>
                    <thead class="roster">
                        <tr>
                            <th width="40">N°</th>
                            <th width="100">Position</th>
                            <th width="5">M</th>
                            <th width="5">F</th>
                            <th width="5">Ag</th>
                            <th width="5">Ar</th>
                            <th width="225">Compétences</th>
                            <th width="225">Evolutions</th>
                            <th width="10">Bls</th>
                            <th width="10">Réu</th>
                            <th width="10">Td</th>
                            <th width="10">Int</th>
                            <th width="10">Sor</th>
                            <th width="10">Mvp</th>
                            <th v-if="current.league.id == 1" width="10">Xp DB</th>
                            <th width="20">Xp</th>
                            <th width="50">Prix</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="roster">
                        <tr v-for="player in current.players">
                            <td v-bind:class="{ miss: player.miss_next_game }" class="number">{{player.num}}</td>
                            <td v-bind:class="{ miss: player.miss_next_game }" >{{player.ref_roster_line}}</td>
                            <td v-bind:class="{ miss: player.miss_next_game }" >{{player.M}}</td>
                            <td v-bind:class="{ miss: player.miss_next_game }" >{{player.F}}</td>
                            <td v-bind:class="{ miss: player.miss_next_game }" >{{player.Ag}}</td>
                            <td v-bind:class="{ miss: player.miss_next_game }" >{{player.Ar}}</td>
                            <td v-bind:class="{ miss: player.miss_next_game }" >
                                <span v-for="skill in player.skills" >
                                        {{skill.name}},
                                </span>
                            </td>
                            <td v-bind:class="{ miss: player.miss_next_game }" >
                                <span v-if="player.upgrades.length" v-for="up in player.upgrades" :class="getUpgradeStyle(up)" >
                                        {{getUpgradeName(up)}},
                                </span>
                                <span v-if="player.downgrades" class="upgrade down">
                                        {{getDowngrades(player)}},
                                </span>
                                <div v-if="player.customizations && player.customizations.length"
                                      v-for="cust in player.customizations" class="upgrade stats">
                                        <span v-if="cust.skills" v-for="skill in cust.skills">{{skill.name}}, </span>
                                </div>
                            </td>
                            <td v-if="player.miss_next_game"><span class="additional_skills">Absent</span></td>
                            <td v-else-if="player.is_journeyman" >Journalier</td>
                            <td v-else>{{player.niggling_injuries}}</td>
                            <td>{{player.nb_passes}}</td>
                            <td>{{player.nb_TD}}</td>
                            <td>{{player.nb_int}}</td>
                            <td>{{player.nb_cas}}</td>
                            <td>{{player.nb_MVP}}</td>
                            <td v-if="current.league.id == 1">
                                {{player.DB_xp}}
                            </td>
                            <td>{{player.total_xp}}</td>
                            <td><span  v-bind:class="{ miss: player.miss_next_game }" class="additional_skills">
                              {{player.base_cost + player.evolution_cost + player.customization_cost}}k</span>
                            </td>
                            <td>
                                <button :id="player.id" @click="showStatsModal(player.id)" class="small">
                                    <span :id="player.id" class="large-btn-icon">Customiser</span>
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td :colspan="nbColumns" class="sous-total right">
                                <div class="row columns">
                                    <div class="large-5 columns">{{current.players.length }} Joueurs Total - {{wounded}} Absents - {{journeymens}} journalier</div>
                                    <div class="large-1 large-offset-5 columns">total</div>
                                </div>
                            </td>
                            <td class="sous-total">{{playersCost}}k</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
            <div class="row">
                <div class="large-5 columns large-offset-7">
                    <table>
                        <tbody class="roster">
                            <tr>
                                <td width="50"><img class="team-icon" src="/static/imgs/icons/dices.png" alt=""></td>
                                <td width="125">Relances</td>
                                <td width="110" >{{current.ref_roster.reroll_price}}k</td>
                                <td width="70">{{current.nb_rerolls}}</td>
                                <td width="150" >{{current.ref_roster.reroll_price*current.nb_rerolls}}k</td>
                            </tr>
                            <tr v-if="current.ref_roster.apo_available">
                                <td><img class="team-icon" src="/static/imgs/icons/red-cross.png" alt=""></td>
                                <td>Apothicaire</td>
                                <td>50 000</td>
                                <td v-if="current.apo">Oui</td>
                                <td v-else>Non</td>
                                <td v-if="current.apo">50k</td>
                                <td v-else>0k</td>
                            </tr>
                            <tr>
                                <td><img class="team-icon" src="/static/imgs/icons/glove.png" alt=""></td>
                                <td>Popularité</td>
                                <td>10k</td>
                                <td>{{current.pop}}</td>
                                <td>{{current.pop*10}}k</td>
                            </tr>
                            <tr>
                                <td><img class="team-icon" src="/static/imgs/icons/coach.png" alt=""></td>
                                <td>Assistants</td>
                                <td>10k</td>
                                <td>{{current.assistants}}</td>
                                <td>{{current.assistants*10}}k</td>
                            </tr>
                            <tr>
                                <td><img class="team-icon" src="/static/imgs/icons/pom-pom.png" alt=""></td>
                                <td>Pom-pom girls</td>
                                <td>10k</td>
                                <td>{{current.cheerleaders}}</td>
                                <td>{{current.cheerleaders*10}}k</td>
                            </tr>
                            <tr>
                                <td class="sous-total right" colspan="3">Budget Annexe</td>
                                <td></td>
                                <td v-if="current.apo == false" class="sous-total">{{current.ref_roster.reroll_price*current.nb_rerolls + current.pop*10 + current.assistants*10 + current.cheerleaders*10}} k</td>
                                <td v-else class="sous-total">{{50 + current.ref_roster.reroll_price*current.nb_rerolls + current.pop*10 + current.assistants*10 + current.cheerleaders*10}} k</td>
                                <td colspan="2"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import store from '../../store/index.js'
import spinner from '../common/spinner.vue'
import messageModal from '../common/message-modal.vue'
import confirmModal from '../common/confirm-modal.vue'
import teamDetailHeader from './team-header/team-detail-header.vue'
import addTreasuryModal from './team-customize-modals/add-treasury-modal.vue'
import playerCustomizeModal from './team-customize-modals/player-customize-modal.vue'
import { mapGetters } from 'vuex'
import mrHeader from '../match-reports/mr-header.vue'
import commentPanel from '../common/comment-panel.vue'
import team from '../../api/team.api'
import spinningModal from '../common/spinning-modal.vue'

export default {
  name: 'teamCustomization',
  components: {
    spinner,
    spinningModal,
    teamDetailHeader,
    messageModal,
    commentPanel,
    confirmModal,
    playerCustomizeModal,
    addTreasuryModal,
    mrHeader
  },
  props: {
    'id': Number
  },
  data () {
    return {
      showSpinner: false,
      showPlayerStatsModal: false,
      showCreatedUpgradeMessage: false,
      showAddTreasuryModal: false,
      clickedPlayerId: null,
      showModePurchaseConfirmModal: false,
      showModeUpgradeConfirmModal: false,
      showActivatedPurchaseModeMessage: false,
      showEndOfSeasonConfirmModal: false,
      showActivateEndOfSeasonMessage: false
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser'
    ]),
    nbColumns: function () {
      if (this.current.league.id === 1) {
        return 16
      }
      return 15
    },
    current: function () {
      return store.getters.detailedTeam
    },
    wounded: function () {
      let woundedCpt = 0
      this.current.players.forEach(player => {
        if (player.miss_next_game) {
          woundedCpt++
        }
      })
      return woundedCpt
    },
    journeymens: function () {
      let journeymensCpt = 0
      this.current.players.forEach(player => {
        if (player.is_journeyman) {
          journeymensCpt++
        }
      })
      return journeymensCpt
    },
    playersCost: function (onlyPlaying = true) {
      let playerCost = 0
      this.current.players.forEach(player => {
        if (!onlyPlaying || !player.miss_next_game) {
          playerCost += (player.base_cost + player.evolution_cost + player.customization_cost)
        }
      })
      return playerCost
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('activateFullSizePage')
    store.dispatch('getDetailedTeam', this.id.toString())
    store.dispatch('getContentType')
    store.dispatch('getMatchReportForTeam', this.id.toString())
  },
  destroyed () {
    store.dispatch('invalidateDetailedTeam')
  },
  methods: {
    showStatsModal (playerId) {
      this.clickedPlayerId = playerId
      this.showPlayerStatsModal = true
    },
    getUpgradeName (upgrade) {
      if (upgrade.status === 0) {
        return ''
      }
      if (upgrade.value === 0 || upgrade.value === 1) {
        return upgrade.skill
      }
      if (upgrade.value === 2) {
        return '+1 M'
      }
      if (upgrade.value === 3) {
        return '+1 Ar'
      }
      if (upgrade.value === 4) {
        return '+1 Ag'
      }
      if (upgrade.value === 5) {
        return '+1 F'
      }
    },
    getUpgradeStyle (upgrade) {
      if (upgrade.type === 0) {
        return 'upgrade base'
      }
      if (upgrade.type === 1) {
        if (upgrade.value === 0) {
          return 'upgrade simple'
        }
        if (upgrade.value === 1) {
          return 'upgrade double'
        }
        if (upgrade.value > 1) {
          return 'upgrade stats'
        }
      }
    },
    getDowngrades (player) {
      if (player.downgrades === null) {
        return ''
      }
      let dwngrd = ''
      if (player.downgrades['M'] !== 0) {
        dwngrd += '-' + player.downgrades['M'].toString(10) + 'M '
      }
      if (player.downgrades['F'] !== 0) {
        dwngrd += '-' + player.downgrades['F'].toString(10) + 'F '
      }
      if (player.downgrades['Ag'] !== 0) {
        dwngrd += '-' + player.downgrades['Ag'].toString(10) + 'Ag '
      }
      if (player.downgrades['Ar'] !== 0) {
        dwngrd += '-' + player.downgrades['Ar'].toString(10) + 'Ar '
      }
      return dwngrd
    },
    finishSeason () {
      this.showEndOfSeasonConfirmModal = false
      this.showSpinner = true
      team.api.finishSeason(this.current.id)
        .then(response => {
          this.$store.dispatch('reloadDetailedTeam')
          this.showSpinner = false
          this.showActivateEndOfSeasonMessage = true
          this.$router.push({
            name: 'TeamDetail',
            params: {
              id: this.current.id
            }
          })
        }, error => {
          console.log('erreur impossible to activate purchase mode')
          console.log(error)
        })
    },
    activateUpgrade () {
      let datas = {}
      datas.status = 2
      team.api.updateTeam(this.current.id, datas)
        .then(response => {
          this.$store.dispatch('reloadDetailedTeam')
          this.showModePurchaseConfirmModal = false
          this.showActivatedPurchaseModeMessage = true
          this.$router.push({
            name: 'TeamDetail',
            params: {
              id: this.current.id
            }
          })
        }, error => {
          console.log('erreur impossible to activate purchase mode')
          console.log(error)
        })
    },
    activatePurchases () {
      let datas = {}
      datas.status = 3
      team.api.updateTeam(this.current.id, datas)
        .then(response => {
          this.$store.dispatch('reloadDetailedTeam')
          this.showModePurchaseConfirmModal = false
          this.showActivatedPurchaseModeMessage = true
          this.$router.push({
            name: 'TeamDetail',
            params: {
              id: this.current.id
            }
          })
        }, error => {
          console.log('erreur impossible to activate purchase mode')
          console.log(error)
        })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.7rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.6rem;
}

.star tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size: 0.8rem;
    font-weight: 500;
    background-color: #E9EDEF;

}

.roster tr td.sous-total{
    font-weight: 600;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{
  margin-right: 0;
  padding-right:0;
  text-align: right;
}

button.row{
    margin-left: 0.4rem;
}

.panel-top {
    padding-top: 0rem;
}

.miss {
    text-decoration: line-through;
}
.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.active {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

.upgrade {
  font-weight: 600;
}

.large-btn-icon {
  font-size: 0.8rem;
}

.note {
    text-align: right;
    font-size: 0.8rem;
}

.down {
  color: #8e2625
}


.stats {
  color: #882e8e
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 1.3rem;
  font-weight: 400;
}
  .validation-btn {
    background-color: #2cb293;
  }

  .validation-btn:hover{
    background-color: #30e3c2;
    color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// team-customize.vue?3ac9c2ec